import type { Config } from "tailwindcss";
import containerQueriesPlugin from "@tailwindcss/container-queries";

/** @type {import('tailwindcss').Config} */
import colors from "tailwindcss/colors";

export default {
  content: [
    "./index.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
    "./node_modules/vue-tailwind-datepicker/**/*.js",
  ],
  theme: {
    extend: {
      colors: {
        "ppa-background": "#F8F8F8",
        "ppa-inactive": "#68788D",
        "ppa-grey": "#68788D",
        "ppa-darker-grey": "#1C2026",
        "ppa-middle-grey": "#B7C5D7",
        "ppa-darker-blue": "#032046",
        "ppa-dark-blue": "#042B5F",
        "ppa-darkest-blue": "#011d41",
        "ppa-white": "#FFFFFF",
        "ppa-white-grey": "#F4F7FA",
        "ppa-white-grey-2": "#FAFCFE",
        "ppa-light-grey": "#DCE0E5",
        "ppa-light-grey-2": "#E4E8ED",
        "ppa-light-grey-3": "#D8E1EE",
        "ppa-light-grey-4": "#8795A7",
        "ppa-light-grey-5": "#E2E9F3",
        "ppa-dark-grey": "#586679",
        "ppa-slate": "#96AAC5",
        "ppa-darker-slate": "#354665",
        "ppa-light-slate": "#F1F7FF",
        "ppa-light-blue": "#E6EAEF",
        "ppa-light-blue-2": "#CAD7E7",
        "ppa-focus-blue": "#042B5F",
        "ppa-dark-red": "#CA113D",
        "ppa-red": "#E61E4D",
        "ppa-light-red": "#FBDDE4",
        "ppa-light-red-2": "#F6B6C5",
        "ppa-light-red-3": "#FFE9EE",
        "ppa-light-rose": "#FBDDE4",
        "ppa-lighter-green": "#ECFCFA",
        "ppa-green": "#097669",
        "ppa-light-green": "#DBEDEB",
        "ppa-dark-green": "#184742",
        "ppa-black": "#0E0E0E",
        "ppa-black-2": "#333333",
        "ppa-logo-green": "#7CC3AE",
        "ppa-logo-blue": "#86A0CC",
        "ppa-logo-purple": "#8F68F5",
        "ppa-skeleton-light": "rgba(0, 0, 0, 0.1)",
        "ppa-skeleton-slightly-lighter": "rgba(0, 0, 0, 0.075)",
        "ppa-skeleton-lighter": "rgba(0, 0, 0, 0.025)",
        "ppa-sidebar-overlay": "rgba(0, 11, 25, 0.35)",
        "ppa-navbar-overlay": "rgba(255, 255, 255, 0.8)",
        "ppa-image-attachment-overlay": "rgba(4, 43, 95, 0.5)",
        "ppa-bulk-selection-separator": "#c9d5e8",
        "vtd-primary": {
          DEFAULT: "#CAD7E7",
          50: "#F8FAFC",
          100: "#F8FAFC",
          200: "#F1F4F9",
          300: "#EDF2F7",
          400: "#E6ECF4",
          500: "#E3EAF2",
          600: "#DCE5EF",
          700: "#D8E2EE",
          800: "#D1DDEA",
          900: "#CEDAE9",
          950: "#CAD7E7",
        },
        "vtd-secondary": {
          DEFAULT: "#0E0E0E",
          50: "#F6F6F6",
          100: "#E7E7E7",
          200: "#D1D1D1",
          300: "#B0B0B0",
          400: "#888888",
          500: "#6D6D6D",
          600: "#5D5D5D",
          700: "#4F4F4F",
          800: "#454545",
          900: "#3D3D3D",
          950: "#0E0E0E",
        },
      },
      backgroundImage: {
        "ppa-skeleton-gradient":
          "linear-gradient(to right, rgba(150,129,219,0.25), rgba(121,186,192,0.25))",
        "ppa-skeleton-gradient-stronger":
          "linear-gradient(to right, rgba(150,129,219,0.3), rgba(121,186,192,0.3))",
      },
      fontSize: {
        "ppa-smaller": "14px",
        "ppa-default": "15px",
        "ppa-big": "18px",
        "ppa-notification-title": "19px",
        "ppa-bigger": "19px",
      },
      zIndex: {
        100: "100",
      },
      boxShadow: {
        "notification-shadow": "0px 0px 28px 0px rgba(4, 43, 95, 0.12)",
        "admin-todo-shadow": "0px 0px 20px #DCE0E5",
        "postlist-card-shadow": "0 0 10px 0 rgba(4, 43, 95, 0.12)",
        "donut-progress-chart-inner": "inset 0 0 24px 0 rgba(183, 197, 215, 0.25)",
        "dashboard-card": "0px 0px 20px #DCE0E5",
        "comment-card": "0px 0px 32px -2px #042b5f14",
        "conversation-card": "0px 0px 28px 0px rgba(4, 43, 95, 0.12)",
        "badge-list": "0 0 8px 2px rgba(4, 43, 95, 0.08)",
      },
    },
  },
  plugins: [containerQueriesPlugin],
  darkMode: "class",
  future: {
    hoverOnlyWhenSupported: true,
  },
} satisfies Config;
